import Badge from "../components/theme-components/Badge";
import BaseButton from "../components/theme-components/BaseButton";
import BaseCheckbox from "../components/theme-components/Inputs/BaseCheckbox";
import BaseDropdown from "../components/theme-components/BaseDropdown";
import BaseHeader from "../components/theme-components/BaseHeader";
import BaseInput from "../components/theme-components/Inputs/BaseInput";
import BaseNav from "../components/theme-components/Navbar/BaseNav";
import BasePagination from "../components/BasePagination";
import BaseProgress from "../components/theme-components/BaseProgress";
import BaseRadio from "../components/theme-components/Inputs/BaseRadio";
import BaseSwitch from "../components/theme-components/BaseSwitch";
import Card from "../components/theme-components/Cards/Card";
import StatsCard from "../components/theme-components/Cards/StatsCard";
import vSelect from "vue-select";

import {
  ElTooltip,
  ElPopover,
  ElLoading,
  // ElSelect,
  ElOption,
} from "element-plus";
const GlobalComponents = {
  install(app) {
    app.component("badge", Badge);
    app.component("base-button", BaseButton);
    app.component("base-checkbox", BaseCheckbox);
    app.component("base-dropdown", BaseDropdown);
    app.component("base-input", BaseInput);
    app.component("base-nav", BaseNav);
    app.component("base-header", BaseHeader);
    app.component("base-pagination", BasePagination);
    app.component("base-progress", BaseProgress);
    app.component("base-radio", BaseRadio);
    app.component("base-switch", BaseSwitch);
    app.component("card", Card);
    app.component("stats-card", StatsCard);
    app.component("v-select", vSelect);
    app.use(ElTooltip);
    app.use(ElPopover);
    app.use(ElLoading);
    // app.use(ElSelect);
    app.use(ElOption);
  },
};

export default GlobalComponents;
